function validateCardPassword(cardPassword: string) {
  const value = cardPassword;
  let message = '';
  let success = false;

  if (!value) {
    message = '비밀번호 입력은 필수입니다.';
  } else if (value.length >= 1 && value.length < 2) {
    message = '정확한 비밀번호를 입력해 주세요.';
  } else {
    message = '';
    success = true;
  }

  return { success, message };
}

export default validateCardPassword;
